import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, DataRoomConfirmation } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDataRoomConfirmationQuery(
	dataRoomGuid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<DataRoomConfirmation, unknown, DataRoomConfirmation, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.Confirmation(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomConfirmation>(
				api.get(CerebroApiEndpoints.DataRooms.Confirmation(dataRoomGuid))
			),
		options
	);
}
